import { isValidPoint } from '@client/store/utils/map-util';
import { getGmapConstructor } from './get-gmap';
import { getGodvMapConstructor } from './get-godv';
const emptyPosition= {
  lng:null,
  lat:null
}
/**
 * 获取自动暂停边界点的序号
 * @param {Array} points 点集合
 * @param {Object} stop 自动暂停时间段对象
 * @param {String} direction 边界方向
 * @return {Number} 无匹配的话返回-1
 */
export function getEdgeIndex4autoStop(points, stop, direction) {
  let left = 0;
  let right = points.length - 1;
  const timestemp2check = stop[direction === 'left' ? 'startTimestamp' : 'endTimestamp'];

  while (left <= right) {
    const middle = left + ((right - left) >> 1);
    if (points[middle].timestamp - timestemp2check >= 0) {
      right = middle - 1;
    } else {
      left = middle + 1;
    }
  }

  let matchedIndex = right;
  const ratio = direction === 'left' ? -1 : 1;
  while (points[matchedIndex] && !isValidPoint(points[matchedIndex])) {
    matchedIndex += ratio;
  }

  return matchedIndex;
}

/**
 * 转换原始位置数据点为地图适配的经纬度数据
 * @param {Object} obj 原始位置数据点
 * @param {Boolean} isGoogleMap 是否为谷歌地图
 * @param {Object} transformedGps 转换后的地图坐标映射
 * @returns {Object|AMap.LngLat} 转换后的经纬度数据
 */
export function transformLatitude(obj, isGoogleMap = false, transformedGps) {
  
  if(!obj) return emptyPosition
  if (isGoogleMap) {
    return {
      lng: obj.gpsLon / 10000000,
      lat: obj.gpsLat / 10000000
    };
  } else {
    // 外层数据已转换
    let item=obj.timestamp
    if(!item) return  emptyPosition
    return transformedGps[item] || emptyPosition
  }
}

const AUTO_PAUSE_BASIS_LINE_CONFIG = {
  aMap: {
    isOutline: false,
    borderWeight: 3,
    strokeOpacity: 1,
    strokeWeight: 6,
    strokeStyle: 'solid',
    strokeDasharray: [10, 5],
    lineJoin: 'round',
    lineCap: 'round',
    zIndex: 51
  },
  google: {
    strokeOpacity: 1.0,
    strokeWeight: 3,
    zIndex: 54
  }
};

/**
 * 渲染自动暂停路径
 * @param {google.maps.Map|AMap} map 地图实例
 * @param {Array}} points 位置点集合
 * @param {Array} pauses 暂停集合
 * @param {String} theme 主题颜色
 * @param {Object} transformedGps 转换后的地图坐标
 */
export async function renderAutoPause({ map, points, pauses, theme, transformedGps, isGoogle = false } = {}) {
  const GmapClass = await getGmapConstructor();
  const GodvMap = await getGodvMapConstructor();
  const autoPauseLines = [];
  const basisConfig4line = AUTO_PAUSE_BASIS_LINE_CONFIG[isGoogle ? 'google' : 'aMap'];
  const PolylineFactory = (isGoogle ? GmapClass : GodvMap).Polyline;
  const strokeColor = theme === 'theme-dark' ? `#768A13` : `#D8E57D`;

  // 考虑自动暂停的时间比较短暂的情况，取暂停时间内的点可能取不到两个及以上的点，取暂停时间段边界有效点
  const parseData4lines = (pause) => {
    const startIndex = getEdgeIndex4autoStop(points, pause, 'left');
    if (startIndex === -1) return;

    const endIndex = getEdgeIndex4autoStop(points, pause, 'right');
    const path = [
      transformLatitude(points[startIndex], isGoogle, transformedGps),
      transformLatitude(points[endIndex], isGoogle, transformedGps)
    ];
    autoPauseLines.push(new PolylineFactory({ path, strokeColor, ...basisConfig4line }));
  };

  pauses.filter((pause) => pause.type === 1).forEach(parseData4lines);

  if (autoPauseLines.length > 0) {
    if (isGoogle) {
      autoPauseLines.forEach((line) => {
        line.setMap(map);
      });
    } else {
      map.add(autoPauseLines);
    }
  }
}
